import { render, staticRenderFns } from "./LoadingTip.vue?vue&type=template&id=628b5213"
import script from "./LoadingTip.vue?vue&type=script&lang=js"
export * from "./LoadingTip.vue?vue&type=script&lang=js"
import style0 from "./LoadingTip.vue?vue&type=style&index=0&id=628b5213&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports